import {studentDetailsActionTypes as types} from '../constants';

export function fetchStudentDetails(studentId, binderFilters, isTeksTeacher) {
  return {type: types.FETCH_STUDENT_DETAILS, payload: {studentId, binderFilters, isTeksTeacher}};
}

export function storeStudentDetails(studentId, details) {
  return {type: types.STORE_STUDENT_DETAILS, studentId, payload: details};
}
